import React from 'react';
import AssetCommand from './AssetCommand';

const AssetCommandList = ({ commands, assetId }) => {
  if (!commands) {
    return <></>;
  }

  return (
    <div>
      { commands.map(command => (
        <AssetCommand
          key={command.name}
          assetId={assetId}
          command={command}
        />
      )
      ) }
    </div>
  );
};

export default AssetCommandList;
